export default __webpack_public_path__ + "static/media/mccree-fishinabarrel.90cacf35.mp3";